// extracted by mini-css-extract-plugin
module.exports = {"root":"Item_root__2P2GU","firstColumn":"Item_firstColumn__1mlYQ","lastColumn":"Item_lastColumn__aH8Vq"};